<template lang="pug">
  div
    resource-table(
      v-if="shouldRenderTable"
      item-key="id"
      :can-show-admin-resources="showAdminResources"
      :can-manage-own-resources="isSaveEnabled"
      :headers="headers"
      :items="contactTypesData"
      :singular-resource="singularResource"
      :plural-resource="pluralResource"
      :place-holder-item="placeHolderItem"
      :should-save="isFormValid"
      :selected-label="selectedLabel"
      :is-loading="isLoading"
      :affected-count="affectedContacts"
      :show-success-message="showSuccess"
      :show-error-message="showError"
      additional-message=""
      @create="handleCreate"
      @edit="handleEdit"
      @cancel="handleCancel"
      @save:create="handleSaveCreate"
      @save:edit="handleSaveEdit"
      @delete="handleDelete"
      @selected-item="setSelectedId"
      @clear-messages="clearMessages"
    )
      template(slot="items" slot-scope="props")
        td
          editable-text-field(
              v-model="props.item.name"
              :is-editing="shouldEdit(props.item)"
              :rules="[...rules, isUnique]"
              @update:error="handleError"
            )
</template>

<script>
import {  mapActions, mapState, mapMutations } from 'vuex';
import ResourceTable from './ResourceTable';
import EditableTextField from './EditableTextField';
import { CONTACTS } from '../config';
import GetSubAccountPermissions from '../mixins/getSubAccountPermissions';
import GetAffectedContacts from '../mixins/getAffectedContacts';
import SortingModal from './SortingModal';

export default {
  name: 'ContactTypes',
  mixins: [GetSubAccountPermissions, GetAffectedContacts],
  components: {
    ResourceTable,
    EditableTextField,
    SortingModal,
  },
  data() {
    return {
      selectedId: '',
      isFormValid: true,
      resourcePermissionsType: CONTACTS.relationshipTypes.resourceType,
      singularResource: CONTACTS.relationshipTypes.singularResource,
      pluralResource: CONTACTS.relationshipTypes.pluralResource,
      placeHolderItem: CONTACTS.relationshipTypes.placeHolderItem,
      headers: CONTACTS.relationshipTypes.headers,
      rules: [
        v => !!v || 'Relationship is required',
        v => (v && v.trim().length > 0) || 'Relationship must be not-empty',
        v => (v && v.length <= 200) || 'Relationship must be less than 200 characters',
      ],
      isDelete: false,
      shouldRenderTable: false,
    };
  },
  watch: {
    async selectedId(value) {
      if (value) {
        await this.findTotalContactsByResource({ typeid: value });
      }
      this.isFormValid = true;
    },
  },
  async mounted() {
    await this.fetchContactTypes();
    this.shouldRenderTable = true;
    this.clearMessages();
  },
  computed: {
    ...mapState({
      isError: state => state.contactTypes.isError,
      isSuccess: state => state.contactTypes.isSuccess,
      isLoading: state => state.contactTypes.isLoading,
      contactTypesData: state => state.contactTypes.contactTypes,
    }),
    selectedLabel() {
      const item = this.contactTypesData.find(i => i.id === this.selectedId);
      return item && item.name;
    },
    showError: {
      get() {
        return this.isError;
      },
      set(value) {
        this.clearMessages();
        this.clearAffectedContactsMessage();
      },
    },
    showSuccess: {
      get() {
        return this.isSuccess;
      },
      set(value) {
        this.clearMessages();
        this.clearAffectedContactsMessage();
      },
    },
  },
  methods: {
    ...mapActions('contactTypes', [
      'fetchContactTypes',
      'saveContactType',
      'updateContactType',
      'deleteContactType',
    ]),
    ...mapMutations('contactTypes', [
      'clearMessages'
    ]),
    handleEdit(itemId) {
      this.selectedId = itemId;
    },
    handleCancel() {
      this.selectedId = null;
      this.isDelete = false;
    },
    handleCreate() {
      this.selectedId = 0;
    },
    async handleSaveCreate(item) {
      item.name = item.name.trim();
      await this.saveContactType(item);
      this.selectedId = null;
      await this.fetchContactTypes();
    },
    async handleSaveEdit(item) {
      item.name = item.name.trim();
      this.selectedId = null;
      await this.updateContactType(item);
      await this.fetchContactTypes();
    },
    async handleDelete(item) {
      this.selectedId = null;
      this.isDelete = false;
      await this.deleteContactType(item.id);
      await this.fetchContactTypes();
    },
    shouldEdit(item) {
      const { id, disabled_by: disabledBy } = item;
      if (this.selectedId === null) return false;
      return this.selectedId === id && !this.isDelete && !disabledBy;
    },
    handleError(value) {
      // if there is error it throws true
      this.isFormValid = !value;
    },
    setSelectedId(itemId) {
      this.isDelete = true;
      this.selectedId = itemId;
    },
    isUnique(value) {
      const disabledBySystem = 'system';
      const nameValNormalized = nameVal.trim().toLowerCase();
      const duplicated =
        value &&
        this.contactTypesData.find(item => {
          const isNotDisabled = !item.disabled_by;
          const isDisabled = item.disabled_by && item.disabled_by === disabledBySystem;
          const isDifferentId = item.id !== this.selectedId;
          const hasSameName = item.name.trim().toLowerCase() === nameValNormalized;

          return (isNotDisabled || isDisabled) && hasSameName && isDifferentId;
        });

      if (duplicated) return 'Relationship must be unique';
      return true;
    },
  },
};
</script>
